import { lazy, Suspense, useEffect, useState } from 'react';

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => {
    return {
      default: d.ReactQueryDevtools,
    };
  }),
);

export const ReactQueryDevToolProvider = () => {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    // @ts-expect-error
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    showDevtools && (
      <Suspense>
        <ReactQueryDevtoolsProduction initialIsOpen buttonPosition="top-right" position="bottom" />
      </Suspense>
    )
  );
};
